<template>
  <div class="container">
    <nav-subtitle :title="'Select a child'" :icon="'people'">
      <template v-slot:nav-subtitle-extra-title>
        <share-child-modal
          title="Share child"
          :childs-list="
            childUsers.filter(
              (c) => c && c.parent && c.parent == userId && (c.child_enabled || showDisabled),
            )
          "
        />
      </template>
    </nav-subtitle>
    <draggable
      v-model="orderedChildrenList"
      group="people"
      @start="drag = true"
      @end="drag = false"
      @change="handleChange"
      class="child-list row m-0 px-0 px-lg-5 mt-3"
      :delay="isMobile ? '200' : '0'"
    >
      <section
        class="child-list__child col-6 col-md-4 col-lg-3 mt-3"
        v-for="(item, index) in orderedChildrenList"
        :key="'child-' + index"
        :class="item && (item.child_enabled || showDisabled) ? '' : 'd-none'"
      >
        <b-link
          v-on:click="() => childClick(item.id, item.child_enabled)"
          class="text-decoration-none"
        >
          <b-img
            v-if="
              item && item.avatar ? !item.avatar.image : item && item.image ? !item.image : true
            "
            fluid
            class="shadow rounded-25 child-avatar"
            :src="require(`@/assets/child-profile-empty.png`)"
          ></b-img>
          <b-img
            v-else
            class="shadow rounded-25 child-avatar"
            :src="item && item.avatar ? item.avatar.image : item && item.image ? item.image : true"
          ></b-img>
          <div class="d-flex justify-content-between ">
            <p class="m-0 text-dark col-9 p-0 ">{{ item && item.name }}</p>
            <div
              class="m-0 text-right text-dark col-3 text-left p-0 d-flex align-items-start justify-content-end"
            >
              <p class="d-flex align-items-center justify-content-center">
                {{ item && item.stars }}
                <b-img
                  :src="require('@/assets/icons/icon-money-star.png')"
                  class="icon-star-small ml-1"
                ></b-img>
              </p>
            </div>
          </div>
        </b-link>
      </section>
      <!-- New child add button-->
      <section class="child-list__create-child col-6 col-md-4 col-lg-3 mt-3" draggable="false">
        <b-link :to="'/register-child'" class="text-decoration-none">
          <b-img
            fluid
            class="shadow rounded-25 child-avatar"
            :src="require(`@/assets/child-profile-empty-plus.png`)"
          ></b-img>
          <p class="m-0 text-center text-muted">Add new child</p>
        </b-link>
      </section>
    </draggable>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';

import navSubtitle from '@/components/general/navSubtitle.vue';
import shareChildModal from '@/components/general/share/shareChild.vue';

export default {
  data() {
    return {
      childUsers: this.users,
      childrenOrder: [],
      orderedChildrenList: [],
      userId: Number,
    };
  },
  props: {
    users: Array,
    router: String,
    showDisabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    navSubtitle,
    draggable,
    shareChildModal,
  },
  computed: {
    ...mapGetters('parent', ['getChildrenOrder']),
    isMobile() {
      return !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    },
  },

  mounted() {
    this.userId = store.getters['user/getUserId'];
    // get children order from database and store on local state
    this.getParentChildrenOrder(this.userId).then(() => {
      this.orderChildrenDate();
      this.childrenOrder = this.getChildrenOrder;
    });
  },
  methods: {
    ...mapActions('user', ['DeleteChild']),
    ...mapActions('parent', ['getParentChildrenOrder']),
    removeChild(id) {
      this.DeleteChild(id);
    },
    handleChange() {
      // save children order on databse and local store
      store
        .dispatch('parent/setParentChildrenOrder', {
          userId: this.userId,
          childrenOrder: this.orderedChildrenList.map((child) => {
            return child.id;
          }),
        })
        .then(() => {
          this.orderChildrenDate();
          this.childrenOrder = this.getChildrenOrder;
        });
    },
    orderChildrenDate() {
      let orderedChilds = [];
      let extraChilds = [];
      let childrenOrder = this.getChildrenOrder;

      // get ordered sublist  using parent preferences
      if (childrenOrder) {
        orderedChilds = childrenOrder.map((childId) => {
          return this.childUsers.filter((c) => c.id == childId)[0];
        });
        // get excedent sublist
        extraChilds = this.childUsers.filter((childId) => !childrenOrder.includes(childId.id));
        this.childUsers = [...extraChilds, ...orderedChilds];
        this.orderedChildrenList = [...extraChilds, ...orderedChilds];
      } else {
        this.orderedChildrenList = this.childUsers;
      }
    },
    // when children is clicked on list
    childClick(childId, childEnabled) {
      // save enabled property of the children
      sessionStorage.setItem('clickedChild', `{"id":${childId},"enable":${childEnabled}}`);
      // redirect to children redirection
      this.$router.push(`${this.router}/${childId}`);
    },
  },
};
</script>
<style scoped>
.rounded-25 {
  border-radius: 10px;
}
.child-avatar {
  object-fit: contain;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.child-list {
  row-gap: 1rem;
}
.child-list__child:hover,
.child-list__create-child:hover {
  /* width: 300px !important; */
  margin-top: 0.5rem !important;
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.child-list__create-child img {
  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.icon-star-small {
  width: 1em;
  height: 1em;
}
</style>
